<mat-sidenav-container class="sidenav-container" style="height: 100vh">
  @if (needsSidenav && !noFrame && !minimalFrame) {
    <mat-sidenav #sidenav class="sidenav" mode="over" autoFocus="false">
      <div fxLayout="column" style="height: 100%">
        <mat-toolbar>
          <mat-icon
            id="sidenav_close_button"
            style="height: 36px; width: 36px; min-width: 36px; font-size: 36px; padding: 0 12px"
            svgIcon="close"
            (click)="sidenav.close()"
          />
          <a [href]="logoHref" (click)="navigateHome($event)">
            <div class="logo-image">
              <img style="height: 100%" src="assets/merkur-logo-extended.png" alt="Logo" />
            </div>
          </a>
        </mat-toolbar>
        <div fxFlex fxLayout="column" style="overflow: auto">
          <div>
            @if (!sidenavTemplateRef()) {
              <mat-nav-list style="padding: 40px 30px">
                @for (actionDef of sidenavActionDefs; track actionDef) {
                  <mng-sidenav-button
                    [actionDef]="actionDef"
                    [active]="isActive(actionDef) || isAnyActive(actionDef.menu)"
                    (executeAction)="executeAction($event)"
                  />
                }
              </mat-nav-list>
            } @else {
              <ng-container
                [ngTemplateOutlet]="sidenavTemplateRef()"
                [ngTemplateOutletContext]="{ $implicit: sidenavActionDefs }"
              />
            }
          </div>
          <div fxFlex></div>
          @if (envInfo) {
            <div class="env-info-sidebar">
              {{ envInfo }}
            </div>
          }
        </div>
        <mat-nav-list style="padding-top: 0" class="sidenav-footer">
          @if (cobrowsingButtonVisible) {
            <mat-list-item (click)="startCobrowsing()">
              <mng-icon matListItemAvatar iconName="merkur:ic_computer" />
              <span matListItemTitle>Live-Hilfe</span>
            </mat-list-item>
          }
          @if (userContextData) {
            <mat-list-item (click)="logout()">
              <mng-icon matListItemAvatar iconName="merkur:ic_logout" />
              <span matListItemTitle>Abmelden</span>
            </mat-list-item>
          }
        </mat-nav-list>
      </div>
    </mat-sidenav>
  }

  <mat-sidenav #sidenavRight class="sidenav" position="end" [mode]="media.isActive('gt-sm') ? 'side' : 'over'">
    <ng-template [cdkPortalOutlet]="sidenavRightService.sidenavPortal | async" />
  </mat-sidenav>

  <mat-sidenav-content class="background-happy" style="height: 100vh; overflow: hidden">
    @if (!noFrame) {
      <mat-toolbar class="sticky-toolbar mat-elevation-z4">
        <mat-toolbar-row>
          @if (needsSidenav && !minimalFrame) {
            <mat-icon
              id="sidenav_open_button"
              style="height: 36px; width: 36px; min-width: 36px; font-size: 36px; padding: 0 12px"
              svgIcon="menu"
              (click)="sidenav.open()"
            />
          }
          <!-- Toolbar -->
          @if (media.isActive('gt-sm')) {
            @if (!minimalFrame) {
              <a [href]="logoHref" (click)="navigateHome($event)">
                <div class="logo-image">
                  <img style="height: 100%" src="assets/merkur-logo-extended.png" alt="Logo" />
                </div>
              </a>
            } @else {
              <div class="logo-image">
                <img style="height: 100%" src="assets/merkur-logo-extended.png" alt="Logo" />
              </div>
            }
          }
          @if (withToolbarTitles) {
            <div class="toolbar-title">{{ frameTitle }}</div>
          }
          <div fxFlex>
            <ng-content select="[toolbar]" />
          </div>
          <div
            id="sidenav_right_button"
            style="margin-right: 16px; cursor: pointer"
            (click)="sidenavRightService.toggle()"
          >
            <ng-template [cdkPortalOutlet]="sidenavRightService.iconPortal | async" />
          </div>
          @if (needsAuth && !minimalFrame) {
            <div style="margin-right: 4px" class="profile-button">
              @if (!userContextData) {
                <button mat-flat-button color="accent" (click)="login()">
                  <mat-icon svgIcon="login-variant" style="margin-top: 8px; margin-right: 0" />
                  @if (media.isActive('gt-xs')) {
                    <span style="margin-left: 10px; display: inline-block">Anmelden</span>
                  }
                </button>
              }
              @if (userContextData) {
                <button mat-flat-button color="accent" (click)="gotoBenutzereinstellungen()">
                  <mat-icon svgIcon="merkur:ic_profile" style="margin-top: 5px; margin-right: 0" />
                  @if (media.isActive('gt-xs')) {
                    <span style="margin-left: 10px; display: inline-block">{{ userContextData.userName }}</span>
                  }
                </button>
              }
            </div>
          }
        </mat-toolbar-row>
        @if (withTabs && !noFrame && !minimalFrame) {
          <mat-toolbar-row class="toolbar-nav" style="padding: 0; height: 48px">
            <nav mat-tab-nav-bar mat-stretch-tabs="false" color="accent" style="width: 100%" [tabPanel]="tabPanel">
              @for (actionDef of currentTabSubnavs; track actionDef) {
                @if (actionDef.isVisible()) {
                  <a mat-tab-link [active]="isActiveRoute(actionDef)" (click)="executeAction(actionDef)">{{
                    actionDef.getTitle().toUpperCase()
                  }}</a>
                }
              }
            </nav>
          </mat-toolbar-row>
        }
      </mat-toolbar>
    }
    <div #scrollContainer style="position: relative; overflow: auto" [style.height]="contentHeight">
      <mat-tab-nav-panel
        #tabPanel
        style="display: block; width: 100%; margin-left: auto; margin-right: auto"
        [style.max-width]="contentWidth"
      >
        <router-outlet (activate)="onActivateRoute($event)" />
      </mat-tab-nav-panel>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
